import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'

Vue.use(ElementUI);

import {post, get, patch, put} from './utils/http'
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;

import store from './utils/variable'
Vue.prototype.$store = store;

import {getSevenDay} from './utils/myutils'
Vue.prototype.$getSevenDay = getSevenDay;

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
